module.exports = __webpack_public_path__ + "img/relax_gaming.45285711.svg";